import { Component, OnInit, OnDestroy, Inject, AfterViewChecked } from '@angular/core';
import { RequestsService } from '../../../services/requests/requests.abstract.service';
import { Subject, Observable, combineLatest, of, ReplaySubject } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Request } from '../../../services/requests/requests.model';
import { map, takeUntil } from 'rxjs/operators';
import { Organisation } from '../../../global.model';
import { Map, TileLayer, Marker, LatLng, LatLngBounds } from 'leaflet';
import { TranslateService } from '@ngx-translate/core';
import { DocumentViewerComponent } from '../../common/document-viewer/modal-image.component';
import { State } from 'src/app/store';
import { Store } from '@ngrx/store';
import { organisationSelector } from 'src/app/global/store/global.selectors';
import { MAP_TILE_ATTRIBUTION, MAP_TILE_URL } from 'src/app/global/consts/map-tiles.const';

@Component({
    selector: 'app-request-detail',
    templateUrl: './request-detail.component.html',
    styleUrls: ['./request-detail.component.scss'],
})
export class RequestDetailComponent implements OnInit, OnDestroy, AfterViewChecked {
    destroy$ = new Subject();
    request: Request;

    loading = false;

    map: Map;
    tileLayer: TileLayer;
    marker: Marker;
    mapNeedInvalidate = false;

    displayedColumns = ['isPublic', 'requestNum', 'userName', 'category', 'updated_at', 'status'];

    constructor(
        private translate: TranslateService,
        private service: RequestsService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<RequestDetailComponent>,
        private store: Store<State>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit() {
        this.loading = true;
        combineLatest([this.service.getRequestDetail(this.data.id), this.store.select(organisationSelector)])
            .pipe(
                takeUntil(this.destroy$),
                map(([req, org]) => {
                    this.request = req;
                    this.createMap(req, org);
                    this.loading = false;
                }),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewChecked(): void {
        if (this.mapNeedInvalidate) {
            this.map?.invalidateSize();
            this.mapNeedInvalidate = false;
        }
    }

    createMap(req: Request, org: Organisation) {
        if (req?.address?.latitude && req?.address?.longitude) {
            this.map = new Map('requests-map', {
                zoomControl: true,
                preferCanvas: true,
                center: new LatLng(req?.address?.latitude || req?.localisation?.coordinates[1], req?.address?.longitude || req?.localisation?.coordinates[0]),
                zoom: 15,
                minZoom: 13,
                maxBounds: new LatLngBounds([
                    [org.bounds?.southWest?.lat, org.bounds?.southWest?.lon],
                    [org.bounds?.northEast?.lat, org.bounds?.northEast?.lon],
                ]),
            });
            this.tileLayer = new TileLayer(MAP_TILE_URL, { attribution: MAP_TILE_ATTRIBUTION });
            this.tileLayer.addTo(this.map);
            this.marker = new Marker(new LatLng(req.address?.latitude || req.localisation?.coordinates[1], req.address?.longitude || req.localisation?.coordinates[0]));
            this.marker.addTo(this.map);
            this.mapNeedInvalidate = true;
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

    dateToString(str: string) {
        const date = new Date(str);
        return new Intl.DateTimeFormat(`${this.translate.currentLang}-CA`).format(date);
    }

    viewImage(img: string) {
        this.dialog.open(DocumentViewerComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            data: { src: img },
            panelClass: 'image-dialog',
        });
    }
}
